import React from 'react'
import cn from 'classnames'

import { IEnabledOrDisabledSquareProps } from './interface'
import './styles.scss'

const bc = 'enabled-or-disabled-square'

const EnabledOrDisabledSquare: React.FC<IEnabledOrDisabledSquareProps> = ({ enabled = false, value }) => {
  return <div className={cn(`${bc}__disabled`, { [`${bc}__enabled`]: enabled })}>{value}</div>
}

export default EnabledOrDisabledSquare
